module.exports = __webpack_public_path__ + "img/ico-error.6a56fce9.svg";